var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoftIcon = function SvgMicrosoftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F65314",
    fillRule: "evenodd",
    d: "M.5 0h7.611v7.611H.5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7FBB41",
    fillRule: "evenodd",
    d: "M8.889 0H16.5v7.611H8.889z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A1F1",
    fillRule: "evenodd",
    d: "m.5 8.388 7.611.001V16H.5z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB0",
    fillRule: "evenodd",
    d: "M8.889 8.389H16.5V16H8.889z",
    clipRule: "evenodd"
  })));
};
export { SvgMicrosoftIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogICAgICB3aWR0aD0iMTciCiAgICAgIGhlaWdodD0iMTYiCiAgICAgIHZpZXdCb3g9IjAgMCAxNyAxNiIKICAgICAgZmlsbD0ibm9uZSIKICAgICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICAgPgogICAgICA8cGF0aAogICAgICAgIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgICAgICBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgZD0iTTAuNSAwSDguMTExNDJMOC4xMTA4MyA3LjYxMTQySDAuNVYwWiIKICAgICAgICBmaWxsPSIjRjY1MzE0IgogICAgICAvPgogICAgICA8cGF0aAogICAgICAgIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgICAgICBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgZD0iTTguODg4NTQgMEgxNi41QzE2LjUgMi41MzcxNCAxNi41MDA0IDUuMDc0MjggMTYuNDk5NSA3LjYxMTQyQzEzLjk2MjggNy42MTA5OCAxMS40MjU3IDcuNjExNDIgOC44ODg5OCA3LjYxMTQyQzguODg4MSA1LjA3NDI4IDguODg4NTQgMi41MzcxNCA4Ljg4ODU0IDBaIgogICAgICAgIGZpbGw9IiM3RkJCNDEiCiAgICAgIC8+CiAgICAgIDxwYXRoCiAgICAgICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgICAgIGNsaXAtcnVsZT0iZXZlbm9kZCIKICAgICAgICBkPSJNMC41IDguMzg4MThDMy4wMzcxNCA4LjM4OTA3IDUuNTc0MjggOC4zODc4OSA4LjExMTQyIDguMzg5MDdDOC4xMTE4NiAxMC45MjYyIDguMTExNDIgMTMuNDYyOSA4LjExMTQyIDE2SDAuNVY4LjM4ODE4WiIKICAgICAgICBmaWxsPSIjMDBBMUYxIgogICAgICAvPgogICAgICA8cGF0aAogICAgICAgIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgICAgICBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgZD0iTTguODg4OTkgOC4zODkwMUMxMS40MjU3IDguMzg4MTMgMTMuOTYyOCA4LjM4ODU3IDE2LjUgOC4zODg1N1YxNkg4Ljg4ODU1QzguODg4OTkgMTMuNDYyOCA4Ljg4ODExIDEwLjkyNTcgOC44ODg5OSA4LjM4OTAxWiIKICAgICAgICBmaWxsPSIjRkZCQjAwIgogICAgICAvPgogICAgPC9zdmc+";